var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchWhiteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.7918 12.1667H12.9359L12.6326 11.8742C13.3096 11.0876 13.8044 10.1612 14.0816 9.16109C14.3588 8.161 14.4115 7.112 14.2359 6.08917C13.7268 3.0775 11.2134 0.672503 8.18009 0.30417C7.11368 0.169258 6.03053 0.280089 5.01354 0.628183C3.99655 0.976277 3.07266 1.55241 2.31258 2.31249C1.5525 3.07257 0.976368 3.99645 0.628275 5.01345C0.280181 6.03044 0.169349 7.11359 0.304261 8.18C0.672595 11.2133 3.0776 13.7267 6.08926 14.2358C7.11209 14.4114 8.16109 14.3587 9.16118 14.0815C10.1613 13.8043 11.0877 13.3095 11.8743 12.6325L12.1668 12.9358V13.7917L16.7709 18.3958C17.2151 18.84 17.9409 18.84 18.3851 18.3958C18.8293 17.9517 18.8293 17.2258 18.3851 16.7817L13.7918 12.1667ZM7.29176 12.1667C4.59426 12.1667 2.41676 9.98917 2.41676 7.29167C2.41676 4.59417 4.59426 2.41667 7.29176 2.41667C9.98926 2.41667 12.1668 4.59417 12.1668 7.29167C12.1668 9.98917 9.98926 12.1667 7.29176 12.1667Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchWhiteIcon);
export default __webpack_public_path__ + "static/media/search-white-icon.c62582bd2a9c971ed972742ddf6753f2.svg";
export { ForwardRef as ReactComponent };